// src/stores/useAuthStore.js
import { defineStore } from 'pinia';
import { supabase } from '../supabase';
import { useMainStore } from './useMainStore';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
  }),
  actions: {
    async fetchUser() {
      const { data: { user } } = await supabase.auth.getUser();
      this.user = user;
    },
    async signInWithEmail(email, password) {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      await this.fetchUser();
    },
    async signUpWithEmail(email, password) {
      const { error } = await supabase.auth.signUp({
        email,
        password,
      });
      if (error) throw error;
    },
    async signInWithGoogle() {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
      });
      if (error) throw error;
      // No need to fetch user here; handled in the auth state change listener
    },
    async signInWithLinkedIn() {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'linkedin_oidc',
      });
      if (error) throw error;
    },
    async signOut() {
      const { error } = await supabase.auth.signOut();
  if (error) throw error;

  // Pinia-Store zurücksetzen, damit keine alten Daten blitzen
  const main = useMainStore();
  main.$reset();                // löscht state (Pinia built-in)

  this.user = null;
    },
    init() {
          supabase.auth.onAuthStateChange((event, session) => {
              // ignore TOKEN_REFRESHED, USER_UPDATED, etc
              if (event === 'SIGNED_IN' || event === 'SIGNED_OUT') {
                this.user = session?.user || null;
              }
            });
    },
  },
});
